// extracted by mini-css-extract-plugin
export default {"data_table_anchored_cell":"aGemX5CTZphr8kn3x5EK","data_table_anchor":"jMKEaioGuPRn7_yB1dSD","linkable_cell_content":"UtaWQwXXH0D0mPTx6bfN"};